import { render, staticRenderFns } from "./CartPromocode.vue?vue&type=template&id=8e3e00de&"
import script from "./CartPromocode.vue?vue&type=script&lang=ts&"
export * from "./CartPromocode.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseInput: require('/home/vsts/work/1/a/NuxtApp/components/base/Input.vue').default,BaseButton: require('/home/vsts/work/1/a/NuxtApp/components/base/Button.vue').default,BaseForm: require('/home/vsts/work/1/a/NuxtApp/components/base/Form.vue').default})
